<template>
  <div class="home-component">
    <h2 v-lang.appName></h2>
    <div v-if="canManageAny">
      <md-card md-with-hover v-if="canManageMember">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title" v-lang.partyMembership></div>
          </md-card-header-text>
          <md-card-media>
            <md-icon>group</md-icon>
          </md-card-media>
        </md-card-header>
        <md-card-actions>
          <md-button class="md-raised md-primary" :to="{ name: 'MemberListPage' }">
            <span v-lang.walkOver></span>
          </md-button>
        </md-card-actions>
      </md-card>
      <md-card md-with-hover v-if="canManageOrg">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title" v-lang.organizations></div>
          </md-card-header-text>
          <md-card-media>
           <md-icon>location_city</md-icon>
          </md-card-media>
        </md-card-header>
        <md-card-actions>
          <md-button class="md-raised md-primary" :to="{ name: 'OrganizationListPage' }">
          <span v-lang.walkOver></span>
          </md-button>
        </md-card-actions>
      </md-card>
      <md-card md-with-hover v-if="canManageDoc">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title" v-lang.documents></div>
          </md-card-header-text>
          <md-card-media>
            <md-icon>description</md-icon>
          </md-card-media>
        </md-card-header>
        <md-card-actions>
          <md-button class="md-raised md-primary" :to="{ name: 'DocumentListComponent' }">
            <span v-lang.walkOver></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import Auth from '@/common/auth'
export default {
  name: 'HomeComponent',
  data () {
    return {
      canManageAny: Auth.CanManageAny(),
      canManageOrg: Auth.CanManageOrgs(),
      canManageMember: Auth.CanManageMembers(),
      canManageDoc: Auth.CanManageDocs()
    }
  },
  created () {
    this.initPartyLabels()
  },
  methods: {
    initPartyLabels () {
      this.organizations = this.translate('organizations')
      this.partyMembership = this.translate('partyMembership')
      this.walkOver = this.translate('walkOver')
    }
  }
}
</script>

<style lang="scss" scoped>
.md-card {
  max-width: 400px;
  width: 100%;
  min-width: 300px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.md-icon{
  width: 30px!important;
  min-width: 30px!important;
  height: 30px!important;
  font-size: 40px !important;
}
.md-card-header .md-card-media{
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue